import { Button, Card, Heading, Stack, Text } from "@softmax/design-system";
import { spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";

export function AccountCredentials({
  userCredentials,
  players,
  playersRefreshing = false,
  onCreatePlayer,
}: {
  readonly userCredentials: ReactNode;
  readonly players: ReactNode;
  readonly playersRefreshing?: boolean;
  readonly onCreatePlayer: () => void;
}) {
  return (
    <Stack width="auto" gap={24}>
      <Card>{userCredentials}</Card>
      <div {...stylex.props(styles.heading)}>
        <div>
          <Heading level={2}>Players</Heading>
          <Text as="p" tone="muted">
            Manage player identities and their credentials.
          </Text>
        </div>
        <Button aria-disabled={playersRefreshing} onClick={onCreatePlayer}>
          Create player
        </Button>
      </div>
      {players}
    </Stack>
  );
}

const styles = stylex.create({
  heading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: spacing.space12,
  },
});
